import React, {useEffect, useState} from 'react';
import {Request, RequestsApiService, useService, Workspace, WorkspacesApiService} from '@innowise-group/core';
import {Loader} from '@innowise-group/ui-kit';
import {SeatRequestProps} from './seat-request.component';
import {catchError, concatMap, of, tap} from 'rxjs';

interface withSeatRequestAndWorkspaceProps extends Omit<SeatRequestProps, 'data'> {}

function withSeatRequestAndWorkspaceDetails(WrappedComponent: React.FC<SeatRequestProps>) {
  return function ({...props}: withSeatRequestAndWorkspaceProps) {
    const {requestId} = props;
    const requestApi = useService(RequestsApiService);
    const [request, setRequest] = useState<Request>(null);
    const [workspace, setWorkspace] = useState<Workspace | null>(null);

    const workspacesApi = useService(WorkspacesApiService);

    useEffect(() => {
      if (requestId) {
        const subscriber = requestApi
          .getWorkspaceRequestById(requestId)
          .pipe(
            concatMap((requestData) => {
              setRequest(requestData);
              return workspacesApi.getWorkspaceById(requestData?.seat?.id).pipe(catchError(() => of(null)));
            }),
            tap(setWorkspace),
          )
          .subscribe();
        return () => subscriber.unsubscribe();
      }
    }, [requestId, requestApi, workspacesApi]);

    if (!request || !workspace) {
      return <Loader />;
    }

    return <WrappedComponent data={{...request, workspace}} {...props} />;
  };
}

export default withSeatRequestAndWorkspaceDetails;
